// extracted by mini-css-extract-plugin
export var blog_tags = "styles-module--blog_tags--a473b";
export var blog_thumb_wrapper = "styles-module--blog_thumb_wrapper--35b8b";
export var blog_title = "styles-module--blog_title--5ef32";
export var image = "styles-module--image--515f2";
export var product_update_wrapper = "styles-module--product_update_wrapper--9851a";
export var text_wrapper = "styles-module--text_wrapper--a06c7";